<script lang="ts" setup>
import type {HTMLAttributes} from 'vue'
import type {LabelProps} from 'radix-vue'
// import { useFormField } from './useFormField'
import {cn} from '@/shared/lib/utils'
import {Label} from '@/shared/components/ui/label'

const props = withDefaults(defineProps<LabelProps & {
  class?: HTMLAttributes['class'],
  error?: boolean
}>(), {
  error: false,
})

// const { error, formItemId } = useFormField()
</script>

<template>
  <Label
      :class="cn(
      error && 'text-red-700 dark:text-red-900',
      props.class,
    )"
  >
    <slot/>
  </Label>
</template>
